// extracted by mini-css-extract-plugin
export default {"svgOverride":"TreeEditor_svgOverride__jDeMH"};